import { AnimatePresence, motion, usePresence } from 'framer-motion'
import React, { useEffect, useState } from 'react'

import useNavigationStore from '@/context/useNavigationStore'
import { transitionEasing } from '@/libs/global-vars'
import { useLocation } from 'react-router-dom'

type RouteTransitionProps = {
  children: React.ReactNode
  direction?: 'horizontal' | 'vertical'
}

const RouteTransition = ({
  children,
  direction = 'horizontal',
}: RouteTransitionProps) => {
  const location = useLocation()

  const transitionDuration = 0.25

  const [isPresent, safeToRemove] = usePresence()
  const { backNav } = useNavigationStore()

  useEffect(() => {
    !isPresent && setTimeout(safeToRemove, transitionDuration * 1000)
  }, [isPresent, safeToRemove])

  const transition = {
    ease: transitionEasing,
    duration: transitionDuration,
  }

  const [animation, setAnimation] = useState(
    direction === 'vertical'
      ? {
          initial: { y: '100%', opacity: 0.01 },
          animate: { y: 0, opacity: 1 },
          exit: { y: '100%', opacity: 0.01 },
        }
      : {
          initial: { x: backNav ? '-100%' : '100%', opacity: 0.01 },
          animate: { x: 0, opacity: 1 },
          exit: { x: backNav ? '100%' : '-100%', opacity: 0.01 },
        },
  )

  useEffect(() => {
    if (direction === 'vertical') return
    setAnimation({
      initial: { x: backNav ? '-100%' : '100%', opacity: 0.01 },
      animate: { x: 0, opacity: 1 },
      exit: { x: backNav ? '100%' : '-100%', opacity: 0.01 },
    })
  }, [backNav, direction])

  return (
    <AnimatePresence>
      <motion.div
        className="w-full h-full"
        variants={animation}
        key={location.key}
        transition={transition}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}

export default RouteTransition
